module.exports = __webpack_public_path__ + "static/system-integration-banner-overlay-2f556f51e8df513e7446690610b48fd5.jpg";